import api from "./api";

export const notificationSettingsApi = {
  get: () => api.get("/notification-settings"),
  update: (payload) => api.put("/notification-settings", payload),
};
